import {TprmQuestionnaireModelId} from "platformed-client/types";
import api from "../../../api";
import {param, typedQuery} from "../../typing";

export const questionnaireModels = typedQuery(["tprm", "questionnaireModels"], async () => {
  return await api.tprm.questionnaireModels.list();
});

export const questionnaireModel = typedQuery(
  ["tprm", "questionnaireModel", param<TprmQuestionnaireModelId>("questionnaireModelId")],
  async questionnaireModelId => {
    return await api.tprm.questionnaireModels.get(questionnaireModelId);
  },
);
